import { InfoMenuDot } from "./InfoMenuDot";

export const customScrollbar = (container, options) => {
    try {
        let axis = 'y';
        let theme = 'inset-dark';
        if (options) {
            if (options.axis) {
                ({ axis } = options);
            }

            if (options.theme) {
                ({ theme } = options);
            }

            if (options.update) {
                if ($(container).hasClass('mCS_destroyed')) {
                    $(container).mCustomScrollbar({
                        axis,
                        theme,
						callbacks:{
							onScrollStart:function(){
								InfoMenuDot.closeAll();
							},
						}
                    });
                } else {
                    $(container).mCustomScrollbar('update');
                }

                return;
            }
        }

        $(container).mCustomScrollbar({
            axis,
            theme,
			callbacks:{
				onScrollStart:function(){
					InfoMenuDot.closeAll();
				},
			}
        });
    } catch (error) {
        console.log(`ERROR: ${error}`);
    }
};



// WEBPACK FOOTER //
// ./src/scripts/shared/customScrollbar.js